
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M8 10a1.929 1.929 0 01-1.417-.583A1.929 1.929 0 016 8c0-.556.194-1.028.583-1.417A1.929 1.929 0 018 6c.556 0 1.028.194 1.417.583.389.39.583.861.583 1.417s-.194 1.028-.583 1.417A1.929 1.929 0 018 10zm-4.667 2c-.366 0-.68-.13-.941-.392A1.284 1.284 0 012 10.667V5.333c0-.366.13-.68.392-.941.26-.261.575-.392.941-.392h9.334c.366 0 .68.13.941.392.261.26.392.575.392.941v5.334c0 .366-.13.68-.392.941a1.284 1.284 0 01-.941.392H3.333zm1.334-1.333h6.666c0-.367.13-.68.392-.942.261-.261.575-.392.942-.392V6.667c-.367 0-.68-.13-.942-.392a1.284 1.284 0 01-.392-.942H4.667c0 .367-.13.68-.392.942a1.284 1.284 0 01-.942.392v2.666c.367 0 .68.13.942.392.261.261.392.575.392.942zM8.307 14.184c-.914-.004-1.829-.289-2.67-.706l.745-.19-.237-.788L4 13.048l.603 1.871.85-.232-.144-.449c.956.46 1.991.762 3.025.762 1.705 0 3.394-.68 4.666-1.83l-.621-.583c-1.11 1.003-2.585 1.604-4.072 1.597zM4.622 3.414c1.158-1.036 2.714-1.655 4.266-1.6.853.029 1.701.328 2.485.717l-.75.19.238.779L13 2.96l-.593-1.95-.856.216.17.56c-.895-.435-1.862-.754-2.833-.783C7.11.95 5.328 1.649 4 2.836l.622.578z","fill":"currentColor"}})])
          )
        }
      }
    